module.exports = __webpack_public_path__ + "img/PODIA.352ffcf1.png";